module.exports = __webpack_public_path__ + "img/CarFinance247_Logo.8f3e3eda.svg";